import type { FC } from "react"
import React from "react"
import { Stack, Skeleton, Text, HStack, Link } from "@chakra-ui/react"
import "react-diff-view/style/index.css"
import { diffLines, formatLines } from "unidiff"
import type { HunkProps } from "react-diff-view"
import { parseDiff, Diff, Hunk } from "react-diff-view"

import GenericModal from "ui/components/GenericModal"
import type { ProposalDetails } from "createProposal/hooks/useImportProposalData"

type DiffCheckerModalProps = {
  isOpen: boolean
  onClose: () => void
  proposalDetails: ProposalDetails
  isImportLoading: boolean
  currentDescription: string
  snapshotURL: string
}

const EMPTY_HUNKS: HunkProps[] = []

const DiffCheckerModal: FC<DiffCheckerModalProps> = ({
  isOpen,
  onClose,
  proposalDetails,
  isImportLoading,
  currentDescription,
  snapshotURL,
}) => {
  // This ensures that descriptions are defined
  const oldDescription = proposalDetails.description || ""
  const newDescription = currentDescription || ""

  const diffText = formatLines(diffLines(oldDescription, newDescription), {
    context: 3,
  })
  const [diff] = parseDiff(diffText, { nearbySequences: "zip" })

  return (
    <GenericModal
      isOpen={isOpen}
      maxWidth="100%"
      mx={0}
      title="Diff checker"
      top={{ base: "0", lg: "0" }}
      onClose={onClose}
    >
      <Stack>
        {isImportLoading ? (
          <Skeleton h={300} w="full" />
        ) : (
          <>
            <Stack width="full">
              <HStack width="full">
                <Text fontWeight="medium" width="50%">
                  Snapshot proposal
                </Text>
                <Text fontWeight="medium" width="50%">
                  Onchain proposal
                </Text>
              </HStack>
              <HStack width="full">
                <Stack width="50%">
                  <Link href={snapshotURL} target="_blank">
                    <Text
                      className="clamp-text-1"
                      color="gray.500"
                      fontSize="xs"
                    >
                      {snapshotURL}
                    </Text>
                  </Link>
                </Stack>
              </HStack>
            </Stack>
            <Diff
              diffType="modify"
              hunks={diff.hunks || EMPTY_HUNKS}
              viewType="split"
            >
              {(hunks) =>
                hunks.map((hunk) => <Hunk key={hunk.content} hunk={hunk} />)
              }
            </Diff>
          </>
        )}
      </Stack>
    </GenericModal>
  )
}

export default DiffCheckerModal
